// extracted by mini-css-extract-plugin
module.exports = {"marqueeBlurredBorder":"marquee_marqueeBlurredBorder__9EhAx","gradientBorder":"marquee_gradientBorder__KYEro"};